var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"no-data-text":"Danh sách trống","item-text":"title","items":_vm.subjects,"item-value":"id","clearable":"","loading":_vm.loading},on:{"change":_vm.onChange,"input":function($event){return _vm.$emit('input', $event)},"update:search-input":_vm.update}},'v-autocomplete',this.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }